import React from 'react';
import {
  useRecoilValue
} from 'recoil';
import { gameProgressState } from '../state';
import { Home } from './Home';
import { Game } from './Game';
import styled from 'styled-components';

const StyledMain = styled.div`
  background-color: transparent;
  max-width: 2400px;
  width: 100%;
  margin:auto;
  height: auto;
  position: relative;
  z-index: 1;
  padding: 10px 0px 30px 0px;
  @media screen and (-ms-high-contrast: active),(-ms-high-contrast: none){
    max-height: 650px;
  }
`;

const Main = () => {
  const gameProgress = useRecoilValue(gameProgressState);

  return (
    <StyledMain>
      {gameProgress === 'home' ? <Home /> : <Game />}
    </StyledMain>
  );
};

export {
  Main
}
